import React from 'react';

const PRODUCT_LABELS = {
  'GASOLINA': 'Gasolina Comum',
  'GASOLINA ADITIVADA': 'Gasolina Aditivada',
  'ETANOL': 'Etanol',
  'DIESEL': 'Diesel',
  'DIESEL S10': 'Diesel S10',
  'GNV': 'GNV',
};

const RADIUS_OPTIONS = [5, 10, 15, 25, 50];

export default function Filters({ product, radius, brand, products, brands, onProductChange, onRadiusChange, onBrandChange }) {
  return (
    <div className="filters">
      <div className="filter-group">
        <label htmlFor="product-select">Combustível</label>
        <select
          id="product-select"
          value={product}
          onChange={(e) => onProductChange(e.target.value)}
        >
          {products.map((p) => (
            <option key={p.product} value={p.product}>
              {PRODUCT_LABELS[p.product] || p.product}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label htmlFor="brand-select">Bandeira</label>
        <select
          id="brand-select"
          value={brand}
          onChange={(e) => onBrandChange(e.target.value)}
        >
          <option value="">Todas</option>
          {brands.map((b) => (
            <option key={b.brand} value={b.brand}>
              {b.brand}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label htmlFor="radius-select">Raio de busca</label>
        <select
          id="radius-select"
          value={radius}
          onChange={(e) => onRadiusChange(parseInt(e.target.value))}
        >
          {RADIUS_OPTIONS.map((r) => (
            <option key={r} value={r}>
              {r} km
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
